import React from 'react';
import { useNavigate } from 'react-router-dom';
import Reveal, { RevealList, RevealItem } from '../components/Reveal';
import '../assets/styles/prices.css';

const priceList = [
  {
    category: 'Eye Treatments',
    description:
      'Refectocil professional eyelash and eyebrow tinting — the leading brand for over 70 years. Results last 4–6 weeks.',
    items: [
      { name: 'Eyebrow shape', time: '15 mins', price: '$25' },
      { name: 'Eyebrow tint', time: '15 mins', price: '$25' },
      { name: 'Eyebrow tint & shape', time: '30 mins', price: '$40' },
      { name: 'Eyelash tint', time: '15 mins', price: '$30' },
      { name: 'Eyelash, eyebrow tint & shape', time: '30 mins', price: '$50' },
      { name: 'Eyelash lift & tint', time: '45 mins', price: '$80' },
    ],
  },
  {
    category: 'Nails',
    description:
      'CND — the global leader in professional nail care — for all manicure treatments. Gel nails with Magpie Beauty: rich colour, brilliant shine, no nasty chemicals.',
    items: [
      { name: 'File & Paint', time: '30 mins', price: '$45' },
      { name: 'Gel nails', time: '1 hr', price: '$65' },
      { name: 'Gel removal + reapplication', time: '1 hr 30 min', price: '$75' },
      { name: 'Spa manicure', time: '60 mins', price: '$75' },
      { name: 'Spa manicure with paraffin mask', time: '75 mins', price: '$90' },
      { name: 'Gel nails & gel toes', time: '90 mins', price: '$120' },
    ],
    extra: [
      'Spa manicure includes a relaxing soak, cuticle care, precise filing, exfoliation, a nourishing mask, and a soothing massage — finished with your choice of polish.',
      'Paraffin masks deeply hydrate and soften, boosting circulation and relieving joint stiffness. Perfect for tired hands and feet.',
    ],
  },
  {
    category: 'Toes',
    items: [
      { name: 'Spa pedicure', time: '60 mins', price: '$85' },
      { name: 'Spa pedicure with paraffin mask', time: '90 mins', price: '$95' },
      { name: 'Gel toes', time: '60 mins', price: '$65' },
      { name: 'Cut nails only', time: '15 mins', price: '$35' },
      {
        name: 'Mini pedicure',
        time: '30 mins',
        price: '$55',
        description: 'For people on the run. I\'ll soak, cut, file and massage your nails — quick, but never rushed.',
      },
    ],
  },
  {
    category: 'Waxing',
    items: [
      { name: 'Half leg', time: '30 min', price: '$45' },
      { name: 'Full leg', time: '45 min', price: '$55' },
      { name: 'Bikini', time: '30+ min', price: '$40+' },
      { name: 'Underarm', time: '30 min', price: '$30' },
      { name: 'Arms', time: '30 min', price: '$35' },
      { name: 'Upper lip', time: '15 min', price: '$20' },
      { name: 'Chin', time: '15 min', price: '$20' },
      { name: 'Lip and chin', time: '30 min', price: '$35' },
    ],
  },
  {
    category: 'Facials',
    description:
      'Proud stockist of Dermalogica and Joyce Blok skincare. Each facial is thoughtfully tailored using advanced formulations and professional techniques to nurture your skin and reveal a radiant, healthy glow.',
    items: [
      {
        name: 'Mini Express',
        time: '30 min',
        price: '$70',
        description:
          'Perfect for busy people. Includes cleansing, exfoliation, and a targeted mask — a quick but genuinely effective treatment.',
      },
      {
        name: 'Joyce Blok Bliss Facial',
        time: '60 min',
        price: '$100',
        description:
          'A made-to-measure treatment with cleansing, toner, exfoliation, facial and neck massage, and a rebalancing mask for a refreshed complexion.',
      },
      {
        name: 'Relaxing Dermalogica Facial',
        time: '60 min',
        price: '$120',
        description:
          'A soothing customised facial using Dermalogica products to cleanse, exfoliate, and hydrate — leaving skin refreshed and glowing.',
      },
      {
        name: 'Dermalogica Nano Fusion Facial',
        time: '60 min',
        price: '$160',
        description:
          'Advanced nano-infusion technology enhances penetration of professional serums to improve hydration, smooth fine lines, and boost radiance — no downtime.',
      },
    ],
  },
  {
    category: 'Massage',
    items: [
      {
        name: 'Aromatherapy massage',
        time: '60 min',
        price: '$90',
        description: 'Back, feet and head. A powerful technique using eight targeted oils for deep relaxation and wellbeing.',
      },
      {
        name: 'Swedish massage — Half body',
        time: '30 min',
        price: '$65',
        description: 'Long gliding strokes, kneading, and circular movements to relax muscles and improve circulation.',
      },
      {
        name: 'Swedish massage — Full body',
        time: '60 min',
        price: '$90',
        description: 'Full-body relaxation and stress relief using classic Swedish techniques.',
      },
      { name: 'Foot massage', time: '20 min', price: '$50' },
      { name: 'Head massage', time: '20 min', price: '$50' },
    ],
  },
  {
    category: 'Gift Vouchers',
    description:
      'Give the gift of self-care. Vouchers are available for any treatment or any dollar value — perfect for birthdays, anniversaries, or just because.',
    extra: [
      'I email it to you once the money reaches me, ready to print or forward on. Redeemable for any treatment, in one visit or across several, and good for three years.',
    ],
    items: [{ name: 'Gift Voucher', time: '', price: '$25+' }],
  },
];

export default function PriceList() {
  const navigate = useNavigate();

  return (
    <div className="price-page">
      <Reveal variant="up" duration={0.55}>
        <div className="price-page-header">
          <p className="price-page-eyebrow">Beauty by Viktoria</p>
          <h1 className="price-page-title">Services & Pricing</h1>
          <p className="price-page-subtitle">
            All treatments are personalised to you. Prices include GST.
          </p>
        </div>
      </Reveal>

      <div className="price-content">
        {priceList.map((section) => (
          <Reveal key={section.category} variant="up" duration={0.5}>
            <section className="price-category" aria-labelledby={`cat-${section.category}`}>
              <div className="price-category-header">
                <h2 className="price-category-title" id={`cat-${section.category}`}>
                  {section.category}
                </h2>
                <div className="price-category-line" aria-hidden="true" />
              </div>

              {section.description && (
                <p className="price-category-desc">{section.description}</p>
              )}

              <RevealList className="price-items" stagger={0.06} role="list">
                {section.items.map((item, idx) => (
                  <RevealItem key={item.name + idx} variant="fade">
                    <div className="price-item" role="listitem">
                      <span className="price-item-name">{item.name}</span>
                      {item.time && <span className="price-item-duration">{item.time}</span>}
                      <span className="price-item-price">{item.price}</span>
                      {item.description && (
                        <p className="price-item-desc">{item.description}</p>
                      )}
                    </div>
                  </RevealItem>
                ))}
              </RevealList>

              {section.extra &&
                section.extra.map((txt, i) => (
                  <p className="price-extra" key={i}>
                    {txt}
                  </p>
                ))}
            </section>
          </Reveal>
        ))}

        <Reveal variant="up" delay={0.1}>
          <div className="price-footer">
            <p className="price-footer-gst">All prices are in NZD and include GST.</p>
            <p className="price-footer-policy">
              <strong>Cancellation policy:</strong> Please give 24 hours' notice if you need to
              cancel — a 50% fee may apply otherwise.
            </p>
            <button
              className="price-footer-cta"
              onClick={() => navigate('/book')}
              aria-label="Book an appointment"
            >
              Book Now
            </button>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
